<template>
  <ColumnWithHelp
    sortable
    :resizable="false"
    :min-width="120"
    :title="$t('ADVERTISEMENT.BID.COLUMN_DESC_AVG_CPI_TITLE')"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_AVG_CPI_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { avgInstallCost } }">
      {{ priceFormat(avgInstallCost) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'AverageInstallCostColumn',
  components: {
    ColumnWithHelp,
  },
  inheritAttrs: false,
  methods: {
    priceFormat,
  },
};
</script>
